import type { WoosMapLocalityDetail, WoosMapLocalityDetailAddressComponent } from "@/modules/woosmap/types"

const getDataFromAddressComponent = (
  type: string,
  addressComponents: WoosMapLocalityDetailAddressComponent[]
): string => {
  return (
    addressComponents.find(component => {
      return component.types[0] === type
    })?.longName || ""
  )
}

type LocalityLevels = {
  city: string
  country: string
  state: string
  subState: string
}

export const getLocalityLevelsByTypes = (result: WoosMapLocalityDetail): LocalityLevels => {
  const { addressComponents } = result

  return {
    city: getDataFromAddressComponent("locality", addressComponents),
    country: getDataFromAddressComponent("country", addressComponents),
    state: getDataFromAddressComponent("state", addressComponents),
    subState: getDataFromAddressComponent("county", addressComponents),
  } as LocalityLevels
}
